"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GitHubRepository = /** @class */ (function () {
    function GitHubRepository(name, full_name, html_url, description, owner) {
        this.name = name;
        this.full_name = full_name;
        this.html_url = html_url;
        this.description = description;
        this.owner = owner;
    }
    return GitHubRepository;
}());
exports.GitHubRepository = GitHubRepository;
//# sourceMappingURL=GitHubRepository.js.map